import job from 'assets/portfolio/image/job.png'
import career from 'assets/portfolio/image/career.png'
import resume from 'assets/portfolio/image/resume.png'
import networking from 'assets/portfolio/image/networking.png'

const AchievementData = [
  {
    img: job,
    title: 'Job Experience',
    content:
      'I achieved an 80% productivity boost by enhancing my coding and problem-solving skills, leading to outstanding job accomplishments and contributions.'
  },
  {
    img: career,
    title: 'Career Guidance',
    content:
      'During my Career Guidance internship, I successfully helped numerous individuals discover their ideal career paths and achieve their professional goals.'
  },
  {
    img: resume,
    title: 'Resume Building',
    content:
      'I excelled in crafting personalized, impactful resumes, enabling candidates to secure their dream jobs through my expertise and attention to detail.'
  },
  {
    img: networking,
    title: 'Build Networking',
    content:
      ' I successfully configured and maintained critical network infrastructure, enhancing system reliability and efficiency while troubleshooting complex issues.'
  }
]

export default AchievementData
